import template from './banktx.html';
import controller from './banktx.controller';

let bankTxComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default bankTxComponent;
